import { toast } from 'react-toastify';
import SuccessToast from '@appcomponents/molecules/SuccessToast';
import { InfoToast } from '../../components/molecules/InfoToast';

export const toastOnSuccess = (
  message: string,
  title?: string,
  onClick?: () => void
) => {
  toast.success(<SuccessToast message={message} title={title} />, {
    hideProgressBar: true,
    position: toast.POSITION.TOP_CENTER,
    onClick,
  });
};

export const toastOnInfo = (
  title: string,
  message?: string,
  onClick?: () => void
) => {
  toast.info(<InfoToast title={title} message={message} />, {
    hideProgressBar: true,
    position: toast.POSITION.TOP_CENTER,
    onClick,
  });
};
